import axios from "axios";


export const api = axios.create({
  baseURL: "https://vqg5y4m707.execute-api.us-east-2.amazonaws.com/Prod",
  headers: {}
});
